module.exports = __webpack_public_path__ + "static/media/heartipro-carrying-case-5.37f995eb.png";